import { IStore, LocalStorageStore } from "./store";
import { useMemo } from "react";

export function usePersistentStore<T>(): IStore<T> {
  return useMemo(() => {
    return new LocalStorageStore<T>();
  }, []);
}
